// ajay:code all 27-08-26
import { Box } from "lucide-react";

const cellLabel = {
  fontSize: 10,
  color: "var(--text3)",
  fontWeight: 600,
  textTransform: "uppercase",
};
const cellValue = { fontSize: 12, color: "var(--text)", marginTop: 1 };
const border = "1px solid var(--border2)";

function Cell({ label, value }) {
  return (
    <div style={{ marginBottom: 8 }}>
      <div style={cellLabel}>{label}</div>
      <div style={cellValue}>{value || "—"}</div>
    </div>
  );
}

export default function ControlPlanSheetHeader({ doc, teamMembers = [] }) {
  const logoUrl = doc?.Company?.logo_url;
  const companyName = doc?.Company?.name;

  const teamCols = 3;
  const teamRows = [];
  for (let i = 0; i < teamMembers.length; i += teamCols) {
    teamRows.push(teamMembers.slice(i, i + teamCols));
  }

  return (
    <div
      style={{ border, borderRadius: 8, overflow: "hidden", marginBottom: 20 }}
    >
      {/* Logo + Title row */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          borderBottom: border,
          background: "var(--surface)",
        }}
      >
        <div
          style={{
            width: 130,
            padding: 10,
            borderRight: border,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {logoUrl ? (
            <img
              src={logoUrl}
              alt={companyName || "Company logo"}
              style={{ maxWidth: "100%", maxHeight: 60, objectFit: "contain" }}
            />
          ) : (
            <div
              style={{
                width: 60,
                height: 60,
                borderRadius: 8,
                background: "var(--surface2)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Box size={22} color="var(--text3)" />
            </div>
          )}
        </div>
        <div style={{ flex: 1, textAlign: "center", padding: 10 }}>
          <div style={{ fontSize: 17, fontWeight: 800, letterSpacing: 0.3 }}>
            CONTROL PLAN
          </div>
          {companyName && (
            <div style={{ fontSize: 11, color: "var(--text3)", marginTop: 2 }}>
              {companyName}
            </div>
          )}
        </div>
        <div
          style={{ width: 160, padding: 10, borderLeft: border, fontSize: 11 }}
        >
          <div>
            <b>Doc No:</b> {doc?.document_no || "—"}
          </div>
          <div>
            <b>Page:</b> {doc?.page || "—"}
          </div>
          <div>
            <b>Issue No:</b> {doc?.issue_no || "—"}
          </div>
          <div>
            <b>Date:</b> {doc?.date || "—"}
          </div>
        </div>
      </div>

      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr" }}>
        {/* Column 1 */}
        <div style={{ borderRight: border, padding: 10 }}>
          <Cell
            label="Contact Person / Phone"
            value={`${doc?.contact_person || "—"} / ${doc?.contact_phone || "—"}`}
          />
          <Cell label="Stage" value={doc?.stage} />
          <div>
            <div style={{ ...cellLabel, marginBottom: 4 }}>Team Members</div>
            {teamRows.length === 0 ? (
              <div style={{ fontSize: 12, color: "var(--text3)" }}>—</div>
            ) : (
              <table style={{ width: "100%", borderCollapse: "collapse" }}>
                <tbody>
                  {teamRows.map((row, i) => (
                    <tr key={i}>
                      {row.map((name, j) => (
                        <td
                          key={j}
                          style={{ fontSize: 11, padding: "3px 6px", border }}
                        >
                          {name}
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        </div>

        {/* Column 2 */}
        <div style={{ borderRight: border, padding: 10 }}>
          <Cell
            label="Supplier's Production Plant"
            value={doc?.supplier_plant}
          />
          <Cell label="Supplier Code" value={doc?.supplier_code} />
          <Cell label="Part Name" value={doc?.part_name} />
          <Cell label="Model" value={doc?.model} />
          <Cell label="Part Number" value={doc?.part_number} />
        </div>

        {/* Column 3 */}
        <div style={{ padding: 10 }}>
          <Cell label="Control Plan No" value={doc?.control_plan_no} />
          <Cell label="Date (Origin)" value={doc?.date_origin} />
          <Cell label="Performed By" value={doc?.performed_by} />
          <Cell
            label="Release Change Level"
            value={doc?.release_change_level}
          />
          <Cell
            label="Rev / Date"
            value={`${doc?.rev_no || "—"} ${doc?.rev_date ? `/ ${doc.rev_date}` : ""}`}
          />
        </div>
      </div>

      {/* Customer approval row */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "1fr 1fr 1fr",
          borderTop: border,
        }}
      >
        <div style={{ borderRight: border, padding: 10 }}>
          <Cell label="Customer" value={doc?.customer_name} />
        </div>
        <div style={{ borderRight: border, padding: 10 }}>
          <Cell
            label="Approved by Customer's Quality"
            value={`${doc?.customer_quality_approved_by || "—"} (${doc?.customer_quality_approved_date || "N/A"})`}
          />
        </div>
        <div style={{ padding: 10 }}>
          <Cell
            label="Approved by Customer's Engg."
            value={`${doc?.customer_engg_approved_by || "—"} (${doc?.customer_engg_approved_date || "N/A"})`}
          />
        </div>
      </div>

      {doc?.rev_description && (
        <div
          style={{
            padding: "8px 10px",
            borderTop: border,
            fontSize: 11,
            color: "var(--text2)",
          }}
        >
          <b>No.</b> {doc?.rev_no || "—"} &nbsp;|&nbsp; <b>Date (Revn.)</b>{" "}
          {doc?.rev_date || "—"} &nbsp;|&nbsp; <b>Modifications:</b>{" "}
          {doc.rev_description}
        </div>
      )}
    </div>
  );
}
